import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useContent } from "../../context/ContentContext";
import { toast } from "sonner";

const LABELS = {
    hero_eyebrow: "Hero · Eyebrow",
    hero_title_part1: "Hero · Title — opening words",
    hero_title_emphasis: "Hero · Title — emphasized words (italic)",
    hero_title_part2: "Hero · Title — closing words",
    hero_subtitle: "Hero · Subtitle",
    hero_cta: "Hero · Primary CTA label",
    journey_eyebrow: "Journey · Eyebrow",
    journey_title: "Journey · Section title",
    journey_subtitle: "Journey · Subtitle",
    benefits_title: "Benefits · Section title",
    about_intro: "About · Intro paragraph",
    footer_tagline: "Footer · Tagline",
    calendly_url: "Calendly · Booking URL (popup opens after lead submission)",
    notification_email: "Notifications · Lead alert recipient (your inbox)",
    agents_eyebrow: "Agents page · Eyebrow",
    agents_title_part1: "Agents page · Title — opening words",
    agents_title_emphasis: "Agents page · Title — italic emphasis",
    agents_title_part2: "Agents page · Title — closing words",
    agents_subtitle: "Agents page · Subtitle",
    agents_cta: "Agents page · Primary CTA label",
    agents_process_eyebrow: "Agents page · Process eyebrow",
    agents_process_title: "Agents page · Process title",
    agents_process_subtitle: "Agents page · Process subtitle",
    agents_benefits_title: "Agents page · Benefits title",
    agents_role_title: "Agents page · Your Role title",
    agents_role_intro: "Agents page · Your Role intro",
    agents_fee_note: "Agents page · Fee / OREA footnote",
    consent_disclaimer: "Get Matched form · Privacy disclaimer (above checkboxes)",
};

export default function AdminContent() {
    const { refresh } = useContent();
    const [items, setItems] = useState({});
    const [saving, setSaving] = useState(null);

    useEffect(() => {
        api.get("/content").then((r) => setItems(r.data || {}));
    }, []);

    const save = async (key) => {
        setSaving(key);
        try {
            await api.patch(`/admin/content/${key}`, { value: items[key] });
            toast.success("Saved");
            await refresh();
        } catch {
            toast.error("Could not save");
        } finally {
            setSaving(null);
        }
    };

    return (
        <div className="p-10" data-testid="admin-content">
            <h1 className="font-serif text-3xl text-brand-ink mb-2">Site text</h1>
            <p className="text-sm text-brand-muted mb-8">
                Edit any text used across the public site. Changes apply immediately.
            </p>

            <div className="space-y-6 max-w-3xl">
                {Object.keys(LABELS).map((key) => (
                    <div key={key} className="border border-brand-line p-5">
                        <div className="text-xs uppercase tracking-wider text-brand-gold font-semibold mb-2">
                            {LABELS[key]}
                        </div>
                        <div className="text-xs text-brand-muted mb-3 font-mono">{key}</div>
                        <textarea
                            value={items[key] || ""}
                            onChange={(e) => setItems({ ...items, [key]: e.target.value })}
                            rows={Math.max(2, Math.ceil((items[key] || "").length / 80))}
                            data-testid={`content-input-${key}`}
                            className="w-full bg-transparent border border-brand-line p-3 text-brand-ink focus:outline-none focus:border-brand-ink"
                        />
                        <div className="mt-3">
                            <button
                                onClick={() => save(key)}
                                disabled={saving === key}
                                data-testid={`content-save-${key}`}
                                className="bg-brand-ink text-brand-paper px-5 py-2 text-sm tracking-wide hover:bg-black disabled:opacity-60"
                            >
                                {saving === key ? "Saving…" : "Save"}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
